import {
    GET_DASHBOARD_INFO,
    GET_DASHBOARD_INFO_FAIL,
    GET_DASHBOARD_INFO_SUCCESS,
    RESET_DASHBOARD_STATE
  } from "./actionTypes";
  
  export const getDashboardInfo = (data) => ({
    type: GET_DASHBOARD_INFO,
    payload: data
  });
  
  export const getDashboardInfoSuccess = general => ({
    type: GET_DASHBOARD_INFO_SUCCESS,
    payload: general,
  });
  
  export const getDashboardInfoFail = error => ({
    type: GET_DASHBOARD_INFO_FAIL,
    payload: error,
  });

  //reset
  export const resetDashboardState = () => {
    return {
        type: RESET_DASHBOARD_STATE,
    }
  }